import { render, staticRenderFns } from "./NoskillPrepareInterview.vue?vue&type=template&id=2b5d2944&scoped=true"
import script from "./NoskillPrepareInterview.vue?vue&type=script&lang=js"
export * from "./NoskillPrepareInterview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5d2944",
  null
  
)

export default component.exports